export default "__VITE_ASSET__d8836c43__"